import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { RelatorioCaixa } from '../models/relatorio-caixa';
import { RelatorioCaixaListItem } from '../models/relatorio-caixa-list-item';

@Injectable({
  providedIn: 'root'
})
export class ConfigurarRelatorioCaixaApiService extends ApiService {

  private readonly baseRoute = '/relatorio-caixa';

  constructor(public override http: HttpClient) {
    super(http);
  }

  public listar(): Observable<RelatorioCaixaListItem[]> {
    return this.get<RelatorioCaixaListItem[]>(this.baseRoute);
  }

  public getById(id: number): Observable<RelatorioCaixa> {
    return this.get<RelatorioCaixa>(`${this.baseRoute}/${id}`);
  }

  public criar(input: RelatorioCaixa): Observable<number> {
    return this.post<number>(this.baseRoute, undefined, this.mapParaRequest(input));
  }

  public editar(id: number, input: RelatorioCaixa): Observable<void> {
    return this.put<void>(`${this.baseRoute}/${id}`, undefined, this.mapParaRequest(input));
  }

  private mapParaRequest(relatorio: RelatorioCaixa) {
    return {
      nome: relatorio.nome,
      categorias: relatorio.categorias.map(c => ({
        id: c.id,
        nome: c.nome,
        identificadorCategoria: c.identificadorCategoria,
        observacaoCategoria: c.observacaoCategoria,
        tipoLancamentoIds: c.tiposLancamento.map(t => t.id),
      })),
    };
  }

  public deletar(id: number): Observable<void> {
    return this.delete<void>(`${this.baseRoute}/${id}`);
  }
}
